<template>
    <div>
        <div class="span-gerar" large v-if="isLoading">
            <span class="loading-spinner"></span>
            <span>GERANDO RESERVAS, AGUARDE.</span>
        </div>
    </div>
</template>

<script>
  import { notification } from '@/plugins/helpers'

  export default {
    name: 'IndicativoReservasComponent',
    props: {
      idCarrinho: {
        required: true,
        type: Number
      },
      erroReserva: {
        required: false,
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        isLoading: true,
        failed: false
      }
    },
    mounted () {
    //   this.gerarReservas()
    },
    methods: {
      async gerarReservas () {
        this.isLoading = true
        try {
          await this.$http.post('/carrinho/reservas/gerar-reservas-carrinho', { id_carrinho: this.idCarrinho })
        } catch (error) {
          this.failed = true
          notification('error', 'Ocorreu um erro ao gerar as reservas')
        } finally {
          this.$emit('listarReservas', this.idCarrinho)
        }
      },
      verificarErroReserva () {
        if (this.erroReserva) {
          this.isLoading = false
          this.failed = true
        }
      }
    }
  }
</script>

<style scoped>
.span-gerar {
    padding: 10px 20px;
    font-size: 10px;
    border: none;
    border-radius: 5px;
    color: #fff;
    background-color: #9c9e9e;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
}

/* HTML: <div class="loader"></div> */
.loading-spinner {
  width: 20px;
  margin-right: 20px;
  aspect-ratio: 1;
  display: grid;
  border-radius: 50%;
  background:
    linear-gradient(0deg ,rgb(0 0 0/50%) 30%,#0000 0 70%,rgb(0 0 0/100%) 0) 50%/8% 100%,
    linear-gradient(90deg,rgb(0 0 0/25%) 30%,#0000 0 70%,rgb(0 0 0/75% ) 0) 50%/100% 8%;
  background-repeat: no-repeat;
  animation: l23 1s infinite steps(12);
}
.loading-spinner::before,
.loading-spinner::after {
   content: "";
   grid-area: 1/1;
   border-radius: 50%;
   background: inherit;
   opacity: 0.915;
   transform: rotate(30deg);
}
.loading-spinner::after {
   opacity: 0.83;
   transform: rotate(60deg);
}
@keyframes l23 {
  100% {transform: rotate(1turn)}
}

@keyframes spin {
to {
    transform: rotate(360deg);
}
}
</style>
